import Component from "./Component.js"

export default class Container extends Component {
  constructor(props, context) {
    super(props, context)
    this.state.components = []
  }

  // TODO: HACK! This is a hack to get around IE 9-10 not inheriting static properties.
  //       Remove this when these browsers are dropped, along with similar code
  //       in other classes that extend Component and Container.
  static get contextTypes() {
    return super.contextTypes
  }

  get components() {
    return this.state.components
  }

  addComponent(component) {
    let components = this.state.components.slice()
    if (component.key == null)
      component.key = akamai.amp.Utils.createUID()
    components.push(component)
    this.setState({components})
  }

  removeComponent(component) {
    let components = this.state.components.filter((item) => item != component)
    this.setState({components})
  }

  clear() {
    this.setState({components: []})
  }

  appendChild(element) {
    let parent = this.dom
    if (parent == null)
      return
    parent.appendChild(element)
  }

  removeChild(element) {
    let parent = this.dom
    if (parent == null)
      return
    parent.removeChild(element)
  }

  get children() {
    return super.children.concat(this.state.components)
  }
}
